import { render, staticRenderFns } from "./OtherUserGroupMemberEdit.vue?vue&type=template&id=bbb61da8&scoped=true&lang=pug"
import script from "./OtherUserGroupMemberEdit.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupMemberEdit.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupMemberEdit.vue?vue&type=style&index=0&id=bbb61da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb61da8",
  null
  
)

export default component.exports